export const ACTIVITIES_FILTER_FIELDS = [
  {
    type: 'dropdown',
    name: 'subject_type',
    label: 'Content type',
    value: '',
    options: [
      {
        text: 'Document',
        value: 'App\\Document'
      },
      {
        text: 'Article',
        value: 'App\\Article'
      },
      {
        text: 'User',
        value: 'App\\User'
      },
      {
        text: 'User Profile',
        value: 'App\\UserProfile'
      },
      {
        text: 'User Role',
        value: 'App\\Role'
      },
      {
        text: 'User Circle',
        value: 'App\\UserCircle'
      },
      {
        text: 'Contact Group',
        value: 'App\\ContactGroup'
      },
      {
        text: 'Country',
        value: 'App\\Country'
      },
      {
        text: 'Group',
        value: 'App\\Group'
      },
      {
        text: 'Permission',
        value: 'App\\Permission'
      },
    ]
  },
  {
    type: 'dropdown',
    name: 'description',
    label: 'Action',
    value: '',
    options: [
      {
        text: 'Updated',
        value: 'updated'
      },
      {
        text: 'Created',
        value: 'created'
      },
      {
        text: 'Deleted',
        value: 'deleted'
      }
    ]
  },
  {
    type: 'dropdown_group',
    name: 'causer_uuid',
    label: 'User',
    value: '',
    apiUrl: 'groups/members/list'
  },
  {
    type: 'date',
    name: 'created_at',
    label: 'Date',
    value: ''
  }
];
